require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-166-lookaheads.json") })
        }
      }, "path---article-166-lookaheads");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-166-lookaheads!./.cache/json/article-166-lookaheads.json
// module id = 514
// module chunks = 231608221292675